import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import CDialog from "shared/CDialog";
import LessonsList from "routes/createContent/views/lessons/views/LessonsList";
import { TemplateFormLesson, buildFormLessonFromLibrary } from "../types";
import LessonPreviewDialog from "./LessonPreviewDialog";
import { usePickerSelection } from "./usePickerSelection";

type LessonListRow = { id: number; title?: string | null; image_url?: string | null };

type Props = {
  open: boolean;
  onClose: () => void;
  existingIds: number[];
  onAdd: (lessons: TemplateFormLesson[]) => void;
};

// Reuses the full Lessons list (filters, search, pagination) in picker mode,
// with the new/edit/delete controls hidden. Selection is tracked here and added
// to the template on confirm.
const LessonPickerDialog: React.VFC<Props> = ({ open, onClose, existingIds, onAdd }) => {
  const { previewId, setPreviewId, checkedIds, toggle, count, selectedItems } = usePickerSelection<
    LessonListRow,
    TemplateFormLesson
  >(open, existingIds, lesson => lesson.id, buildFormLessonFromLibrary);

  const handleAdd = () => {
    onAdd(selectedItems());
    onClose();
  };

  return (
    <>
      <CDialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <Box px={3} pb={2}>
          <Typography variant="h6" gutterBottom>
            Add lessons
          </Typography>
          <LessonsList pickerMode checkedIds={checkedIds} onPickToggle={toggle} onPreview={setPreviewId} />
        </Box>
        <Box
          px={3}
          py={2}
          display="flex"
          justifyContent="flex-end"
          style={{ gap: 12, position: "sticky", bottom: 0, background: "#fff", borderTop: "1px solid #e0e0e0" }}
        >
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" disabled={count === 0} onClick={handleAdd}>
            Add {count > 0 ? count : ""} lesson{count === 1 ? "" : "s"}
          </Button>
        </Box>
      </CDialog>
      <LessonPreviewDialog lessonId={previewId} onClose={() => setPreviewId(null)} />
    </>
  );
};

export default LessonPickerDialog;
